import boxOpenIcon from "@loot-os/icons/icons/box-open";
import type { IconData } from "@loot-os/icons/types";
import type { ReactNode } from "react";
import { cn } from "../foundations/cn.js";
import { cardStyles } from "./Card.styles.js";
import { Icon } from "./Icon.js";

export interface EmptyStateProps {
  /** A short, honest line: "Your vault is empty". */
  title: string;
  /** What to do about it, in a sentence. */
  body?: string;
  icon?: IconData;
  /** One way forward, usually a Button. */
  action?: ReactNode;
  className?: string;
}

/** Where a list or grid would be, when it has nothing to show. */
export function EmptyState({
  title,
  body,
  icon = boxOpenIcon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        cardStyles({ radius: "2xl" }),
        "flex flex-col items-center gap-3 px-6 py-10 text-center",
        className,
      )}
    >
      <span className="flex size-14 items-center justify-center rounded-pill bg-bg-raised text-text-secondary">
        <Icon icon={icon} size={24} />
      </span>
      <p className="font-body text-heading-h2 text-text-primary">{title}</p>
      {body && <p className="max-w-sm font-body text-body-b1 text-text-secondary">{body}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
